/**
 *  @class
 *  @function ImageHotspots
 */
if (!customElements.get('image-hotspots')) {
  class ImageHotspots extends HTMLElement {
    constructor() {
      super();

      this.dots = this.querySelectorAll('.image-hotspots--pin');
      this.buttons = this.querySelectorAll('.image-hotspots--pin-button');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.activeDot = this.buttons.length ? this.buttons[0] : false;

      /** Set `data-hotspots-context="slideshow"` on the element (slideshow section). */
      this.isSlideshowContext = this.dataset.hotspotsContext === 'slideshow';

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);

      this.dots.forEach((dot) => {
        if (!this.isSlideshowContext) {
          this.checkCardPosition(dot);
        }
        dot.addEventListener('click', (event) => {
          if (this.isSlideshowContext) {
            event.stopPropagation();
          }
          this.onClick(dot);
        });
      });
    }

    connectedCallback() {
      if (this.animations_enabled && !this.isSlideshowContext) {
        this.prepareAnimations();
      }
      if (this.isSlideshowContext) {
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeyDown);
      }
    }

    disconnectedCallback() {
      if (this.isSlideshowContext) {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeyDown);
      }
    }

    setPinExpanded(dot, expanded) {
      const btn = dot.querySelector('.image-hotspots--pin-button');
      if (btn && btn.tagName === 'BUTTON') {
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    closeAllPins() {
      this.dots.forEach((dot) => {
        if (!dot.classList.contains('active')) return;
        dot.classList.remove('active');
        this.setPinExpanded(dot, false);
        setTimeout(() => {
          dot.classList.remove('bottom-dot');
          dot.style.setProperty('--content-offset', '0px');
        }, 350);
      });
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.closeAllPins();
      }
    }

    onKeyDown(event) {
      if (event.key !== 'Escape') return;
      const hasActive = Array.from(this.dots).some((pin) => pin.classList.contains('active'));
      if (!hasActive) return;
      this.closeAllPins();
      const firstButton = this.querySelector('.image-hotspots--pin-button');
      if (firstButton) firstButton.focus();
    }

    onClick(dot) {
      this.dots.forEach((thedot) => {
        if (dot === thedot) return;
        thedot.classList.remove('active');
        this.setPinExpanded(thedot, false);
      });
      this.activeDot = dot;
      this.checkCardPosition(dot);
      dot.classList.toggle('active');
      this.setPinExpanded(dot, dot.classList.contains('active'));
      if (!dot.classList.contains('active')) {
        setTimeout(() => {
          dot.classList.remove('bottom-dot');
          dot.style.setProperty('--content-offset', '0px');
        }, 350);
      }
    }

    prepareAnimations() {
      let section = this;

      this.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 50%"
        }
      });

      this.tl
        .fromTo(this.buttons, {
          scale: 0
        }, {
          duration: 2,
          stagger: {
            each: 0.2,
            onComplete() {
              this.targets()[0].classList.add('hotspot--pinned');
            }
          },
          scale: 1,
          ease: 'elastic.out(1.2, 0.5)',
        }
      );
    }

    checkCardPosition(dot) {
      const bubble = dot.querySelector('.image-hotspots--pin-bubble');
      if (!bubble) return;

      dot.classList.remove('bottom-dot');
      dot.style.setProperty('--content-offset', '0px');

      const dotBounds = bubble.getBoundingClientRect();
      const imageBounds = this.getBoundingClientRect();

      if (dotBounds.bottom > document.documentElement.clientHeight || dotBounds.bottom > imageBounds.bottom) {
        dot.classList.add('bottom-dot');
      }
      if (dotBounds.right > imageBounds.right) {
        dot.style.setProperty('--content-offset', `${imageBounds.right - dotBounds.right - 30}px`);
      } else if (dotBounds.left < imageBounds.left) {
        dot.style.setProperty('--content-offset', `${imageBounds.left - dotBounds.left + 30}px`);
      }
    }
  }
  customElements.define('image-hotspots', ImageHotspots);
}